import React from "react"
import { ScrollView, FlatList, Pressable, Text, View } from "react-native"

import { VerticalDivider } from "../Common-Widget"

import AppTheme from "../../../AppTheme"
import AppStyles from "../../../AppStyles"
import TextStyle from "../../../TextStyle"

export const ProductCategoriesFilterView = (props) => {
    let category = props.category
    let productCategoryList = props?.productCategoryList

    let subCategory = props?.subCategory
    let productSubCategoryList = props.productSubCategoryList

    let action = ({ category, subCategory = null }) => props?.action({ category, subCategory })

    // const [productSubCategories, setProductSubCategories] = useState([])

    function isCategorySelected(_category) {
        let isSelected = false
        if (category && category.cid == _category.cid)
            isSelected = true
        return isSelected
    }

    function isSubCategorySelected(_category) {
        let isSelected = false
        if (subCategory && subCategory.cid == _category.cid)
            isSelected = true
        return isSelected
    }

    const SubCategoryView = (subCategory) => {
        const isSelected = isSubCategorySelected(subCategory)
        var borderRadius = 14
        var textColor = AppTheme.color.primary
        var backgroundColor = AppTheme.color.white
        if (isSelected) {
            textColor = AppTheme.color.white
            backgroundColor = AppTheme.color.violet.bg
        }
        return <Pressable onPress={() => action({ category: category, subCategory: subCategory })}
            style={[AppStyles.px8, AppStyles.alignCenter, { backgroundColor: backgroundColor, borderRadius: borderRadius, height: 28 }]}>
            <Text style={[TextStyle.text12b, TextStyle.alignCenter, { color: textColor }]}>
                {subCategory.name}</Text>
        </Pressable>
    }

    return <ScrollView style={[AppStyles.py12, AppStyles.pl16, AppStyles.appWidth, AppStyles.bgWhite]}
        horizontal={true} showsHorizontalScrollIndicator={false}>
        <Pressable onPress={() => {}} style={[AppStyles.mr12]}>
            {isCategorySelected(category) ? productSubCategoryList && productSubCategoryList.length ?
                <View style={[AppStyles.flexRowStart, AppStyles.borderViewPrimary, AppStyles.bgPrimary, { borderRadius: 16, height: 32 }]}>
                    <Text style={[TextStyle.text14b, TextStyle.colorWhite, AppStyles.mx8]}>
                        {category.name}</Text>
                    <FlatList data={productSubCategoryList} horizontal={true}
                        style={[AppStyles.bgWhite, { flexDirection: "row", borderRadius: 15, height: 30, padding: 1 }]}
                        keyExtractor={(item, index) => "deal_view_" + item.cid + '_' + index}
                        renderItem={({ item, index }) => SubCategoryView({ ...item, index: index })}
                        ItemSeparatorComponent={({ item, index }) => <VerticalDivider height={8} marginHorizontal={8} />} />
                </View> : <View style={[AppStyles.borderViewPrimary, AppStyles.bgPrimary, { borderRadius: 16 }]}>
                    <Text style={[TextStyle.text14b, TextStyle.colorWhite]}>
                        {category.name}</Text>
                </View> : <Text style={[TextStyle.text14b, TextStyle.colorPrimary]}>{category.name}</Text>}

        </Pressable>
        {/* {productCategoryList && productCategoryList.length ?
            <FlatList data={productCategoryList} horizontal={true}
                keyExtractor={(item, index) => "deal_view_" + item.cid + '_' + index}
                renderItem={({ item, index }) => CategoryFilterView({ ...item, index: index })}
                snapToAlignment="start" /> : null} */}
    </ScrollView>
}